export enum FeatureFlag {
  DepartmentLookup = 'department_lookup',
  MailerLookup = 'mailer_lookup',
  OrderPreferences = 'order_preferences',
  ShopifyReturns = 'shopify_returns',
  ShopCompanies = 'shop_companies',
  GeneralBookkeepingAccounts = 'general_bookkeeping_accounts',
  GeneralBookkeepingSettings = 'general_bookkeeping_settings',
  VippsMobilepayGateway = 'vipps_mobilepay_gateway',
  PaymentTermFooterTemplateTriggers = 'payment_term_footer_template_triggers',
  BankIntegrations = 'bank_integrations',
  ShopifyTaxDuties = 'shopify_tax_duties',
  ShowDeprecatedPlatforms = 'show_deprecated_platforms',
}
